import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseUpdateTemplate1Request, UseUpdateTemplate1Data } from "@api/@types/consent";

export const useUpdateTemplate1 = createApiMutation<UseUpdateTemplate1Data, UseUpdateTemplate1Request>({
  mutationFn: (req) => apiClientManager.apis.consent.updateTemplate1(req as UseUpdateTemplate1Request),
});

export type { UseUpdateTemplate1Request, UseUpdateTemplate1Data } from "@api/@types/consent";
